export default "__VITE_ASSET__6deba63c__"